/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';


export interface ServiceOffering { 
    id?: number;
    cnpj?: string;
    professionName?: string;
    specialty?: string;
    activityAreas?: Array<string>;
    adultCare?: boolean;
    pediatricCare?: boolean;
    serviceFormatOnLine?: boolean;
    serviceFormatPresential?: boolean;
    address?: Address;
    availability?: Array<number>;
    creationDate?: string;
    publicationDate?: string;
    expirationPublicationDate?: string;
    amount?: number;
    billingUnit?: string;
    description?: string;
    status?: ServiceOffering.StatusEnum;
    emergencyService?: boolean;
    emergencyServiceAvailability?: Array<number>;
}
export namespace ServiceOffering {
    export type StatusEnum = 'DRAFT' | 'OPEN' | 'CLOSE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Open: 'OPEN' as StatusEnum,
        Close: 'CLOSE' as StatusEnum
    };
}


